import React from 'react';
import LegalPageLayout from './LegalPageLayout';
import { betaDisclaimer } from './legalContent';

const BetaDisclaimer = () => {
  return <LegalPageLayout document={betaDisclaimer} />;
};

export default BetaDisclaimer;
